import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  generateQrCode,
  getPlayerSubscription,
  playerDiscountPackageAdd,
  playerPayment,
  ReportPlayerPayment,
} from "../../../services/academicService";
import Select from "react-select";
import { use } from "react";
import {
  getPublicDiscountType,
  getPublicPaymentType,
  getPublicPlanType,
} from "../../../services/publicService";
import Swal from "sweetalert2";

const DuesPaymentModal = ({ show, onClose, userData, onPaymentSuccess }) => {
  const [packageData, setPackageData] = useState([]);
  const [paymentMode, setPaymentMode] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
  const [discountTypes, setDiscountTypes] = useState([]);
  const [selectedDiscountType, setSelectedDiscountType] = useState(null);
  const [planTypes, setPlanTypes] = useState([]);
  const [selectedPlanType, setSelectedPlanType] = useState(null);
  const [formData, setFormData] = useState({
    amountDeposited: "",
    receiptNo: "",
    description: "",
    discountValue: "",
  });
  const [qrData, setQrData] = useState(null);
  const [qrModalShow, setQrModalShow] = useState(false);

  const hasDueAmount = Number(userData?.dueAmount) > 0;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!formData.amountDeposited) {
      toast.error("All fields are required");
      return;
    }

    if (!userData?.id) {
      toast.error("Select user not found");
      return;
    }

    const payload = {
      billId: userData?.id,
      amount: Number(formData.amountDeposited),
      //   subscriptionId: hasDueAmount
      //     ? userData?.subscription?.id
      //     : selectedPackage?.value,
      //   receiptNumber: formData.receiptNo,
      //   paymentType: selectedPaymentMode?.value,
      description: formData.description,
      // discountValue: Number(formData.discountValue),
      // discountValueType: selectedDiscountType?.value,
      // discountType: selectedPlanType?.value,
    };
    console.log("Payment Payload:", payload);
    // call your API here
    const res = await ReportPlayerPayment(payload);
    if (res) {
      toast.success("Payment submitted successfully");
      onPaymentSuccess();
      resetForm();
    }
  };

  useEffect(() => {
    fetchPackage();
    fetchPaymentModes();
    fetchDiscountTypes();
    fetchPlanTypes();
  }, []);

  async function fetchPackage() {
    try {
      const res = await getPlayerSubscription();
      setPackageData(res);
    } catch (error) {
      console.error("Error fetching package types:", error);
    }
  }

  async function fetchPaymentModes() {
    try {
      const res = await getPublicPaymentType();
      setPaymentMode(res);
    } catch (error) {
      console.error("Error fetching package types:", error);
    }
  }

  async function fetchDiscountTypes() {
    try {
      const res = await getPublicDiscountType();
      setDiscountTypes(res);
    } catch (error) {
      console.error("Error fetching discount types:", error);
    }
  }

  async function fetchPlanTypes() {
    try {
      const res = await getPublicPlanType();
      setPlanTypes(res);
    } catch (error) {
      console.error("Error fetching plan types:", error);
    }
  }

  useEffect(() => {
    if (userData?.subscription && packageData.length) {
      const matchedPackage = packageData.find(
        (pkg) => pkg.id === userData.subscription.id,
      );

      if (matchedPackage) {
        setSelectedPackage({
          value: matchedPackage.id,
          label: `${matchedPackage.packageType?.name} (Amount : ${matchedPackage.ammount} INR)`,
        });
      }
    }
  }, [userData?.subscription?.id, packageData, show]);

  // const getPackageAmount = () => {
  //   if (!selectedPackage) return 0;

  //   const pkg = packageData.find((item) => item.id === selectedPackage.value);

  //   return Number(pkg?.ammount || 0);
  // };

  // useEffect(() => {
  //   if (!selectedPackage) return;

  //   const pkg = packageData.find((item) => item.id === selectedPackage.value);

  //   const packageAmount = Number(pkg?.ammount || 0);
  //   const discountValue = Number(formData.discountValue || 0);

  //   let discountAmount = 0;

  //   if (selectedDiscountType?.value === "PERCENTAGE") {
  //     // Allow only 1-100%
  //     const percentage = Math.min(Math.max(discountValue, 0), 100);

  //     discountAmount = (packageAmount * percentage) / 100;
  //   } else {
  //     // Fixed amount
  //     discountAmount = discountValue;
  //   }

  //   const finalAmount = Math.max(packageAmount - discountAmount, 0);

  //   setFormData((prev) => ({
  //     ...prev,
  //     amountDeposited: finalAmount,
  //   }));
  // }, [
  //   selectedPackage,
  //   formData.discountValue,
  //   selectedDiscountType,
  //   packageData,
  // ]);

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const resetForm = () => {
    setSelectedPackage(null);
    setSelectedPaymentMode(null);
    setSelectedDiscountType(null);
    setSelectedPlanType(null);

    setFormData({
      amountDeposited: "",
      receiptNo: "",
      description: "",
      discountValue: "",
    });
  };

  const handleAddDiscount = async () => {
    if (selectedDiscountType?.value === "PERCENTAGE") {
      const percentage = Number(formData.discountValue);
      if (percentage < 0 || percentage > 100) {
        toast.error("Percentage must be between 0 and 100");
        return;
      }
    }
    if (
      !formData.amountDeposited ||
      !formData.receiptNo ||
      !selectedPaymentMode
    ) {
      toast.error("All fields are required");
      return;
    }

    if (!hasDueAmount && !selectedPackage) {
      toast.error("Please select a package");
      return;
    }

    const discountValue = Number(formData.discountValue || 0);

    // Validate discount fields only when discount is greater than 0
    if (discountValue > 0) {
      if (!selectedDiscountType) {
        toast.error("Please select Discount Type");
        return;
      }

      if (!selectedPlanType) {
        toast.error("Please select Plan Type");
        return;
      }
    }
    try {
      const payload = {
        playerId: userData?.id,
        amount: Number(formData.amountDeposited),
        subscriptionId: hasDueAmount
          ? userData?.subscription?.id
          : selectedPackage?.value,
        receiptNumber: formData.receiptNo,
        paymentType: selectedPaymentMode?.value,
        description: formData.description,
        // discountValue: Number(formData.discountValue),
        // discountValueType: selectedDiscountType?.value,
        // discountType: selectedPlanType?.value,
      };

      const res = await playerDiscountPackageAdd(payload);
      if (res) {
        Swal.fire(
          "Discount applied Successful!",
          "Player discount and package has been applied successfully.",
          "success",
        );
        handleClose();
      }
    } catch (error) {
      console.error("Error applying discount:", error);
      toast.error("Failed to apply discount. Please try again.");
    }
  };

  const handleGenerateQR = async () => {
    const payload = {
      playerId: userData?.id,
      amount: Number(formData.amountDeposited),
    };
    const res = await generateQrCode(payload);
    if (res) {
      setQrData(res);
      setQrModalShow(true);
    }
  };

  const amount = userData?.playerSubscription?.amount || 0;
  const discount = userData?.playerSubscription?.discountAmount || 0;
  const payableAmount = amount - discount;

  return (
    <>
      <Modal show={show} onHide={onClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Payment</Modal.Title>
        </Modal.Header>

        <Modal.Body size="l">
          <div className="row">
            {/* Due Amount (NOW ALWAYS VISIBLE) */}
            <div className="col-sm-6 mb-3">
              <label className="form-label text-danger">Due Amount</label>
              <input
                type="number"
                name="dueAmount"
                placeholder="Due Amount"
                className="form-control"
                value={userData?.dueAmount ?? 0}
                readOnly
              />
            </div>

            <div className="col-sm-6">
              <div className="form-group">
                <label className="form-label">
                  Package <span className="text-danger">*</span>
                </label>
                <Select
                  isSearchable={false}
                  options={packageData?.map((pkg) => ({
                    value: pkg?.id,
                    label: `${pkg?.packageType?.name} (Amount : ${pkg?.ammount} INR)`,
                  }))}
                  placeholder="Select Package"
                  className="custom-react-select"
                  value={selectedPackage}
                  onChange={setSelectedPackage}
                  isDisabled
                  readOnly
                />
              </div>
            </div>

            {/* {userData?.playerSubscription?.discountValue > 0 && (
              <>
                {userData?.playerSubscription?.discountValueType ===
                "PERCENTAGE" ? (
                  <div className="col-sm-6 mb-3">
                    <label className="form-label">Discount (%)</label>
                    <input
                      type="text"
                      className="form-control"
                      value={`${userData?.playerSubscription?.discountValue}%`}
                      readOnly
                    />
                  </div>
                ) : (
                  <div className="col-sm-6 mb-3">
                    <label className="form-label">Discount (₹)</label>
                    <input
                      type="text"
                      className="form-control"
                      value={`₹${userData?.playerSubscription?.discountValue}`}
                      readOnly
                    />
                  </div>
                )}
                <div className="col-sm-6 mb-3">
                  <label className="form-label">Amount to be Deposited</label>
                  <input
                    type="number"
                    name="dueAmount"
                    placeholder="Total Amount"
                    className="form-control"
                    value={userData?.playerSubscription?.payableAmount ?? 0}
                    readOnly
                  />
                </div>
              </>
            )} */}

            {/* <div className="col-sm-6">
              <div className="form-group">
                <label className="form-label">
                  Payment Mode <span className="text-danger">*</span>
                </label>
                <Select
                  isSearchable={false}
                  options={paymentMode?.map((mode) => ({
                    value: mode?.value,
                    label: mode?.label,
                  }))}
                  placeholder="Select Payment Mode"
                  className="custom-react-select"
                  value={selectedPaymentMode}
                  onChange={setSelectedPaymentMode}
                />
              </div>
            </div> */}

            {/* Amount Deposited */}
            <div className="col-sm-6 mb-3">
              <label className="form-label">
                Amount <span className="text-danger">*</span>
              </label>
              <input
                type="number"
                name="amountDeposited"
                placeholder="Enter ammount to be deposited"
                className="form-control"
                value={formData.amountDeposited}
                onChange={handleChange}
              />
            </div>

            {/* Receipt No
            <div className="col-sm-6 mb-3">
              <label className="form-label">
                Receipt No <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                name="receiptNo"
                className="form-control"
                placeholder="Enter receipt number"
                value={formData.receiptNo}
                onChange={handleChange}
              />
            </div> */}

            {/* <div className="col-sm-6">
            <div className="form-group">
              <label className="form-label">Discount Type</label>
              <Select
                isSearchable={false}
                options={discountTypes?.map((mode) => ({
                  value: mode?.value,
                  label: mode?.label,
                }))}
                placeholder="Select Discount Type"
                className="custom-react-select"
                value={selectedDiscountType}
                onChange={setSelectedDiscountType}
              />
            </div>
          </div> */}

            {/*  Discount Type */}
            {/* <div className="col-sm-6">
            <div className="form-group">
              <label className="form-label">Discount Type</label>
              <Select
                isSearchable={false}
                options={discountTypes?.map((mode) => ({
                  value: mode?.value,
                  label: mode?.label,
                }))}
                placeholder="Select Discount Type"
                className="custom-react-select"
                value={selectedDiscountType}
                onChange={setSelectedDiscountType}
              />
            </div>
          </div> */}

            {/*  Discount */}
            {/* <div className="col-sm-6 mb-3">
            <label className="form-label">Discount</label>
            <input
              type="number"
              name="discountValue"
              placeholder={
                selectedDiscountType?.value === "PERCENTAGE"
                  ? "Enter percentage (1-100)"
                  : "Enter discount amount"
              }
              className="form-control"
              value={formData.discountValue}
              onChange={handleChange}
            />
          </div> */}

            {/*  Discount Limitation */}
            {/* <div className="col-sm-6">
            <div className="form-group">
              <label className="form-label">Plan Type</label>
              <Select
                isSearchable={false}
                options={planTypes?.map((mode) => ({
                  value: mode?.value,
                  label: mode?.label,
                }))}
                placeholder="Select Plan Type"
                className="custom-react-select"
                value={selectedPlanType}
                onChange={setSelectedPlanType}
              />
            </div>
          </div> */}

            <div className="col-sm-6 mb-3">
              <label className="form-label">Description</label>
              <input
                type="text"
                name="description"
                className="form-control"
                placeholder="Enter description"
                value={formData.description}
                onChange={handleChange}
              />
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleClose}>
            Cancel
          </Button>
          {/* <Button variant="outline-info" onClick={handleGenerateQR}>
            Generate QR
          </Button> */}
          <Button variant="primary" onClick={handleSubmit}>
            Pay Now
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={qrModalShow}
        onHide={() => setQrModalShow(false)}
        centered
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Scan & Pay</Modal.Title>
        </Modal.Header>

        <Modal.Body
          className="d-flex flex-column justify-content-center align-items-center"
          style={{ height: "400px", overflow: "hidden" }}
        >
          <h4 className="fw-bold">Amount: ₹{qrData?.amount}</h4>
          <img
            src={qrData?.qrImageUrl}
            alt="QR Code"
            style={{
              width: "350px",
              height: "350px",
              objectFit: "cover",
              objectPosition: "left center", // adjust as needed
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={() => setQrModalShow(false)}
          >
            Cancel
          </Button>
          <Button variant="outline-warning" onClick={handleGenerateQR}>
            Re-Generate
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              const link = document.createElement("a");
              link.href = qrData?.qrImageUrl;
              link.download = "qr-code.png";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }}
          >
            Download QR
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DuesPaymentModal;
